import * as React from "react";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAllPatientCaseList } from "../../redux/effects/ApiCall";
import { AppState } from "../../redux/store/Store";
import { useHistory } from "react-router-dom";
import { Pagination, Typography } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { PatientCaseList } from "../../redux/interfaces/Model";
import { t } from "i18next";
import {
  DataGrid,
  GridCellParams,
  GridColDef,
  GridToolbar,
} from "@mui/x-data-grid";
import MWExceptionList from "../../component/MWExceptionList";

export default function ActiveAllCaseList() {
  const dispatch = useDispatch();
  const history = useHistory();

  function gotoDetails(patientId: number, caseId: number) {
    history.push(`/casedetails/${patientId}/${caseId}`);
  }

  const [dataGridArray, setDataGridArray] = useState([] as any[]);
  const [pageListCount, setPageListCount] = React.useState("");
  // encounter list api call ...
  useEffect(() => {
    dispatch(getAllPatientCaseList(page, 1));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const AllCaseListValue = useSelector((state: AppState) => state.allcaseValue);
  const allcaseValues = AllCaseListValue.allcaseValue.patientCaseList;

  useEffect(() => {
    AllCaseListValue?.pageCount !== undefined
      ? setPageListCount(String(AllCaseListValue?.pageCount))
      : setPageListCount("0");
    if (allcaseValues !== undefined) {
      let dataPointArr = allcaseValues.map((element: PatientCaseList) => ({
        id: element.caseId,
        caseId: element.caseId,
        patientId: element.patientId,
        patientName: element.patientName,
        WhyWant2ndOpinion: element.whyWant2ndOpinion,
        reasons: element.secondOpinionReasons,
        consultType: element.consultationType,
        docTeamType: element.doctorTeamType,
      }));
      setDataGridArray(dataPointArr);
    } else {
      setPageListCount(String(AllCaseListValue?.pageCount));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AllCaseListValue]);

  const [page, setPage] = useState(1);
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    dispatch(getAllPatientCaseList(value, 1));
  };

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: `${t("patientcaselistpage.view", { ns: ["home"] })!}`,
      width: 100,
      align: "left",
      flex: 1,
      renderCell: (params: GridCellParams) => (
        <Button
          startIcon={<VisibilityIcon />}
          onClick={() => {
            gotoDetails(params.row.patientId, params.row.caseId);
          }}
          variant="outlined"
        >
          {t("patientcaselistpage.view", { ns: ["home"] })!}
        </Button>
      ),
    },
    {
      field: "caseId",
      headerName: `${t("patientcaselistpage.caseid", { ns: ["home"] })!}`,
      width: 150,
      align: "left",
      flex: 1,
    },
    {
      field: "patientId",
      headerName: `${t("patientcaselistpage.userid", { ns: ["home"] })!}`,
      width: 150,
      align: "left",
      flex: 1,
    },
    {
      field: "patientName",
      headerName: `${t("patientcaselistpage.patientname", { ns: ["home"] })!}`,
      editable: true,
      width: 200,
      align: "left",
      flex: 1,
    },
    {
      field: "WhyWant2ndOpinion",
      headerName: `${t("patientcaselistpage.WhyWant2ndOpinion", { ns: ["home"] })!}`,
      editable: true,
      width: 200,
      align: "left",
      flex: 1,
    },
    {
      field: "reasons",
      headerName: `${t("patientcaselistpage.secondopinion", { ns: ["home"] })!}`,
      type: "string",
      width: 200,
      align: "left",
      flex: 1,
    },
    {
      field: "consultType",
      headerName: `${t("patientcaselistpage.consultationtype", { ns: ["home"] })!}`,
      sortable: false,
      width: 100,
      align: "left",
      flex: 1,
    },
    {
      field: "docTeamType",
      headerName: `${t("patientcaselistpage.doctorteamtype", { ns: ["home"] })!}`,
      width: 100,
      align: "left",
      flex: 1,
    },
  ];

  const activeCaseListPage = (
    <Card>
      <CardHeader
        title={
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-start"
          >
            <Grid item>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="flex-end"
              >
                <Grid item>
                  <Typography>Page: {page}</Typography>
                </Grid>
                <Grid item>
                  <Pagination
                    color="primary"
                    count={Number(pageListCount)}
                    page={page}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
      />
      <CardContent>
        {allcaseValues && allcaseValues.length ? (
          <DataGrid
            rows={dataGridArray}
            columns={columns}
            disableSelectionOnClick
            hideFooter
            hideFooterPagination
            experimentalFeatures={{ newEditingApi: true }}
            autoHeight
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: {
                csvOptions: { disableToolbarButton: true },
                printOptions: { disableToolbarButton: true },
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 250 },
              },
            }}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
          />
        ) : (
          <MWExceptionList />
        )}
      </CardContent>
    </Card>
  );

  return <Box>{activeCaseListPage}</Box>;
}
